import React from "react";
import {useParams, useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {RiEyeLine, RiEyeOffLine} from "react-icons/ri";
import {operatorLogin, operatorForgotKey} from "../../../Services/operatorFunctions";
import {
    Page, Left, HandMark, LmRow, LmBadge, LmText, Illustration, Bubble, Line, Avatar, Pitch, Footer,
    Right, Form, Logo, Title, Sub,
    Label, Input, KeyWrap, Eye, FieldErr, RowBetween, Check, ForgotLink, Submit, Toast,
} from "./styles";

const emailValid = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

const LeftPanel = ({t}) => (
    <Left>
        <HandMark/>
        <LmRow>
            <LmBadge>LM</LmBadge>
            <LmText>{t("words.launch_manager")}<span>{t("words.operator_console")}</span></LmText>
        </LmRow>

        <Illustration>
            <Bubble style={{top: "4%", right: "6%", width: "300px"}}>
                <Line $strong $w="72%"/>
                <Line $w="90%"/>
                <Line $w="55%"/>
            </Bubble>
            <Avatar $color="#22C55E" $size={30} style={{top: "26%", right: "1%"}}/>

            <Bubble $tail style={{top: "46%", left: "2%", width: "320px"}}>
                <Line $strong $w="40%"/>
                <Line $w="86%"/>
                <Line $w="78%"/>
                <Line $w="46%"/>
            </Bubble>
            <Avatar $color="#22C55E" $size={54} style={{top: "48%", left: "64%"}}>DS</Avatar>
            <Avatar $color="#F5A623" $size={62} style={{top: "60%", left: "50%"}}>AP</Avatar>
            <Avatar $color="#EC4899" $size={50} style={{top: "80%", left: "64%"}}>MS</Avatar>
        </Illustration>

        <Pitch>
            <h2>{t("words.login_pitch_title")}</h2>
            <p>{t("words.login_pitch_body")}</p>
        </Pitch>
        <Footer>{t("words.login_footer")}</Footer>
    </Left>
);

const OperatorLogin = () => {
    const {campaignId} = useParams();
    const history = useHistory();
    const {t} = useTranslation();
    const [email, setEmail] = React.useState("");
    const [accessKey, setAccessKey] = React.useState("");
    const [showKey, setShowKey] = React.useState(false);
    const [keep, setKeep] = React.useState(false);
    const [errors, setErrors] = React.useState({});
    const [toast, setToast] = React.useState("");
    const [submitting, setSubmitting] = React.useState(false);

    const canSubmit = emailValid(email) && accessKey.trim() && !submitting;

    const submit = async () => {
        if (!canSubmit) return;
        setSubmitting(true);
        setErrors({});
        try {
            const data = await operatorLogin(campaignId, {email: email.trim(), access_key: accessKey.trim(), keep_signed_in: keep});
            localStorage.removeItem("token"); // invariante: chave única (owner sai)
            localStorage.setItem("operator_session_token", data.token);
            history.push(`/campaign/${campaignId}/manager/inbox`);
        } catch (e) {
            const r = e?.response?.data;
            if (r?.field) setErrors({[r.field]: t(`words.login_err_${r.reason}`)});
            else setErrors({key: t("words.login_err_generic")});
            setSubmitting(false);
        }
    };

    const forgot = async () => {
        if (!emailValid(email)) {
            setErrors({email: t("words.login_err_incorrect_email")});
            return;
        }
        await operatorForgotKey(campaignId, email.trim());
        setToast(t("words.login_forgot_toast"));
    };

    return (
        <Page>
            <LeftPanel t={t}/>
            <Right>
                <Form>
                    <Logo/>
                    <Title>{t("words.login_title")}</Title>
                    <Sub>{t("words.login_sub")}</Sub>

                    {toast && <Toast>{toast}</Toast>}

                    <Label>{t("words.email")}</Label>
                    <Input type="email" value={email} $err={!!errors.email}
                           onChange={(e) => setEmail(e.target.value)} aria-label={t("words.email")}/>
                    {errors.email && <FieldErr>{errors.email}</FieldErr>}

                    <Label>{t("words.access_key")}</Label>
                    <KeyWrap>
                        <Input type={showKey ? "text" : "password"} value={accessKey} $err={!!errors.key}
                               onChange={(e) => setAccessKey(e.target.value)} aria-label={t("words.access_key")}/>
                        <Eye type="button" onClick={() => setShowKey((v) => !v)} aria-label="toggle">
                            {showKey ? <RiEyeOffLine/> : <RiEyeLine/>}
                        </Eye>
                    </KeyWrap>
                    {errors.key && <FieldErr>{errors.key}</FieldErr>}

                    <RowBetween>
                        <Check>
                            <input type="checkbox" checked={keep} onChange={(e) => setKeep(e.target.checked)}/>
                            {t("words.keep_signed_in")}
                        </Check>
                        <ForgotLink type="button" onClick={forgot}>{t("words.forgot_key")}</ForgotLink>
                    </RowBetween>

                    <Submit type="button" onClick={submit} disabled={!canSubmit}>{t("words.sign_in")}</Submit>
                </Form>
            </Right>
        </Page>
    );
};

export default OperatorLogin;
